'use client'

import { Box } from '@mantine/core'

interface NavBadgeProps {
    /** Unread count; the badge renders nothing when this is 0 or less. */
    count: number
    /** Pill height in px; font size and padding scale from it. */
    size?: number
    /** `data-testid` for callers whose tests assert the rendered count. */
    testId?: string
}

/**
 * Blue unread-count pill, capped at "9+". Purely presentational — callers own
 * placement (e.g. absolute overlay on the bottom nav, inline on the side nav).
 */
export function NavBadge({ count, size = 18, testId }: NavBadgeProps) {
    if (count <= 0) return null

    return (
        <Box
            data-testid={testId}
            miw={size}
            h={size}
            px={Math.round(size / 3.6)}
            style={{
                flexShrink: 0,
                borderRadius: 999,
                background: 'var(--gm-blue)',
                color: '#FFF',
                fontSize: Math.round(size * 0.6),
                fontWeight: 700,
                lineHeight: `${size}px`,
                textAlign: 'center',
            }}
        >
            {count > 9 ? '9+' : count}
        </Box>
    )
}
